const raf = require('raf');

const easeInOutCubic = (t, b, c, d) => {
  const cc = c - b;
  t /= d / 2;
  if (t < 1) {
    return cc / 2 * t * t * t + b;
  }
  return cc / 2 * ((t -= 2) * t * t + 2) + b; // eslint-disable-line
};

function getDefaultTarget () {
  return window;
}

class Backtop {
  constructor () {
    this.visibilityHeight = 500;
    this.$backTop = this.$el.find('.back-top');
    this.flag = true;
    this.bindEvents();
  }

  bindEvents () {
    $(window).on('scroll', () => this.handleScroll());
    this.$backTop.on('click', () => this.scrollToTop());
  }

  handleScroll () {
    const scrollTop = this.getScroll(window);
    if (scrollTop > this.visibilityHeight && this.flag) {
      this.$backTop.addClass('show');
      this.flag = false;
    } else if (scrollTop < this.visibilityHeight && !this.flag) {
      this.$backTop.removeClass('show');
      this.flag = true;
    }
  }

  getScroll (target) {
    if (typeof window === 'undefined') {
      return 0;
    }
    const prop = 'pageYOffset';
    const method = 'scrollTop';
    const isWindow = target === window;

    let ret = target[prop];
    // ie6,7,8 standard mode
    if (isWindow && typeof ret !== 'number') {
      ret = document.documentElement[method];
    }
    return ret;
  }

  scrollToTop () {
    const scrollTop = this.getCurrentScrollTop();
    const startTime = Date.now();
    const frameFunc = () => {
      const timestamp = Date.now();
      const time = timestamp - startTime;
      this.setScrollTop(easeInOutCubic(time, scrollTop, 0, 450));
      if (time < 450) {
        raf(frameFunc);
      } else {
        this.setScrollTop(0);
      }
    };
    raf(frameFunc);
  }
  getCurrentScrollTop () {
    const getTarget = getDefaultTarget;
    const targetNode = getTarget();
    if (targetNode === window) {
      return window.pageYOffset || document.body.scrollTop || document.documentElement.scrollTop;
    }
    return targetNode.scrollTop;
  }
  setScrollTop (value) {
    const getTarget = getDefaultTarget;
    const targetNode = getTarget();
    if (targetNode === window) {
      document.body.scrollTop = value;
      document.documentElement.scrollTop = value;
    } else {
      targetNode.scrollTop = value;
    }
  }
}
module.exports = Backtop;
